/* eslint-disable no-redeclare */

export type OneOrMany<T> = T | Array<T>;

export const OneOrMany = {
  asArray: <T>(value: OneOrMany<T> = []): Array<T> => {
    return Array.isArray(value) ? value : [value];
  },
};
